<template>

  <div class="row">
	 
    <div class="col-xl-12">
      <h4 class="title">Notifications Log</h4>
      <p class="category">
      List of scheduled reminders that have been sent out to clients' officers.
      </p>
    </div>
    
    
    
        <div class="card">
   		
          <div class="card-body table-responsive table-full-width">
          	
				<el-table :data="notifications"">
					<el-table-column label="Company Name" property="entity_name" min-width=140></el-table-column>
					<el-table-column label="Mode Of Notification" property="mode" min-width=140></el-table-column>
					<el-table-column label="Type" min-width=320>
						<template slot-scope="scope">
							<span v-if="scope.row.notification_type=='passed_fye'"  > 
								Reminder: FYE Passed
							</span>	 
							<span v-if="scope.row.notification_type=='30d_to_agm'"  > 
								Reminder: 30 Days To AGM Deadline
							</span>	 
	
						</template>
					</el-table-column>
					<el-table-column label="Sent To" property="sent_to" min-width=220></el-table-column>
					<el-table-column label="Date Sent" property="date_sent" min-width=220></el-table-column>
				</el-table>
				
				
				
          </div>
        </div>
        
        
    
   
  
  </div>
</template>
<script>
  import Vue from 'vue'
  
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import users from './users'
  
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
     
    
    data () {
      return {
      	notifications:[],
      	tableTd:'',

      
      }
    },
    mounted() {
    	  swal.showLoading();
     	  let uri = this.$base_url+'/api/v1/entities/get/notification_log';
		  ApiService.get(uri).then(response => {
		  		this.notifications = response.data.notifications;
		  		 swal.close();
		  
		  });
    },
    methods: {
      loadTaskTable(vr){
      	 
      
      },
      
    }
  }
</script>
<style lang="scss">

  
</style>
